module.exports = __webpack_public_path__ + "dba92ad10dceee084ef25f118fd12d09.jpg";